//存全部数据
export const GET_ALL_DATA = "get_all_data";
//请求全部数据
export const REQ_ALL_DATA = "req_all_data";
//初始化数据
export const INIT_ALL_DATA = "init_all_data";
//初始化请求
export const INIT_REQ_ALL_DATA = "init_req_all_data";
//删除
export const DELETE_DATA = "delete_data";
